import spinnerAnimation from "@/animations/spinner.json";
import Lottie from "lottie-react";
import React from "react";

interface Props {
  fullScreen?: boolean;
}

export default function Loader({ fullScreen }: Props) {
  return (
    <React.Fragment>
      {fullScreen ? (
        <div className="flex items-center justify-center h-[calc(100vh-120px)]">
          <Loader />
        </div>
      ) : (
        <Lottie
          height={8}
          width={8}
          loop={true}
          animationData={spinnerAnimation}
          style={{ width: 32, height: 32 }}
        />
      )}
    </React.Fragment>
  );
}
